import React from "react";

// Hooks
import { useNavigate } from "react-router-dom";

// MUI Components
import { Box, Button, Container, Typography } from "@mui/material";

// Icons
import { NoContactCIcon } from "~/assets/images";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// styles
import "./styles.scss";


const NoTemplateScreen = () => {
  const navigate = useNavigate();
  return (
    <Container
      maxWidth="xl"
      sx={{
        margin: "120px auto 50px",
      }}
    >
      <Box className="noTemplateWrapper">
        <img src={NoContactCIcon} alt="no-contacts" />
        <Typography>You have no Templates in your database</Typography>
        <Button onClick={() => navigate("/create-template")}>
          <AddCircleOutlineIcon />
          Create New Template
        </Button>
      </Box>
    </Container>
  );
};

export default NoTemplateScreen;
